export default __webpack_public_path__ + "static/reed-2--mobile-7d85fe4c3ca48899394bd2ada0f45072.webp";